import { render, staticRenderFns } from "./CheckActivity.vue?vue&type=template&id=15bf1b64&"
import script from "./CheckActivity.vue?vue&type=script&lang=js&"
export * from "./CheckActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports